"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameValidator = void 0;
const forms_1 = require("@angular/forms");
// validation function
class NameValidator {
    constructor() {
        this.validator = this.fullNameFactory();
    }
    validate(c) {
        return this.validator(c);
    }
    fullNameFactory() {
        return (c) => {
            let isValidName;
            let isLastNameAvail;
            let firstName;
            let lastName;
            const regex = /^[a-zA-Z'.\\ \t]*$/;
            if ((c.value !== undefined) && (c.value !== null) && (c.value).toString().indexOf(' ') >= 0) {
                firstName = (c.value).toString().split(' ')[0];
                lastName = (c.value).toString().split(' ')[1];
                if (firstName.length > 0 && lastName.length > 0 && lastName != null) {
                    isValidName = true;
                    if (regex.test(firstName) && regex.test(lastName)) {
                        isLastNameAvail = true;
                    }
                }
            }
            if (isLastNameAvail && isValidName) {
                return null;
            }
            if (isLastNameAvail && !isValidName) {
                return {
                    invalidName: {
                        valid: false
                    }
                };
            }
            if (!isLastNameAvail && isValidName) {
                return {
                    lastNameAvail: {
                        valid: false
                    }
                };
            }
            else {
                return {
                    lastNameAvail: {
                        valid: false
                    },
                    invalidName: {
                        valid: false
                    }
                };
            }
        };
    }
}
exports.NameValidator = NameValidator;
//# sourceMappingURL=name.validator.js.map